import React from "react";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";

const DeleteAllowedUrlDialog = props => (
  <BaseDialog
    show={props.show}
    onHide={props.onHide}
    size="xs"
    title={props.t("SingleNetworkProfile.AllowedUrlsTab.DeleteModal.Title")}
    dialogApiError={props.dialogApiError}
    body={(<p>{props.t("SingleNetworkProfile.AllowedUrlsTab.DeleteModal.Text")}</p>)}
    leftButtonVariant="black"
    rightButtonVariant="red"
    leftButtonText={props.t("DialogCancel")}
    leftButtonCallback={props.onHide}
    rightButtonText={props.t("SingleNetworkProfile.AllowedUrlsTab.DeleteModal.Confirm")}
    rightButtonCallback={props.onSubmit}
  />
);

export default withTranslation()(DeleteAllowedUrlDialog);
